import React from 'react';

const Footer = () => <div className='content-footer' />;

export default Footer;
